import { Component, Input, OnInit } from '@angular/core';
import { LeadStatusEnum } from '../../enum/lead/lead-status.enum';

@Component({
  selector: 'app-lead-status-badge',
  templateUrl: './lead-status-badge.component.html',
  styleUrls: ['./lead-status-badge.component.css']
})
export class LeadStatusBadgeComponent implements OnInit {
  @Input() value: string;

  leadStatusEnum = LeadStatusEnum;

  constructor() {}

  ngOnInit(): void {}
}
